import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, Subscription } from 'rxjs';
import {
	distinctUntilChanged,
	first,
	map,
	mapTo,
	shareReplay,
	skipWhile,
	tap,
} from 'rxjs/operators';
import { asLoadingState } from './state/with-loading-state.operator';

export class ObservableDataSource<T> extends MatTableDataSource<T> {
	private readonly _refresh = new Subject<void>();
	private readonly _subscription = new Subscription();
	private readonly _disconnected = new Subject<void>();

	private readonly _state$ = asLoadingState(
		this.source,
		this._refresh.asObservable()
	).pipe(shareReplay(1));

	readonly state$ = this._state$.pipe(map(({ state }) => state));

	constructor(readonly source: Observable<T[]>) {
		super([]);
		this._subscription.add(
			this._state$.subscribe((loadingState) => {
				if (loadingState.state === 'loaded') {
					this.data = loadingState.value ?? [];
				}
			})
		);
	}

	refresh(): Observable<void> {
		return this.state$.pipe(
			distinctUntilChanged(),
			tap(() => this._refresh.next()),
			skipWhile((state) => state !== 'pending'),
			first((state) => state !== 'pending'),
			mapTo(undefined)
		);
	}

	disconnect() {
		this._subscription.unsubscribe();
		this._disconnected.next();
		super.disconnect();
	}
}
